var React = require('react');

function CollapseInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M-9.53674e-07 6L14 6L14 8L-1.0411e-06 8L-9.53674e-07 6Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"14","height":"14"})))]);
}

CollapseInline.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CollapseInline;

CollapseInline.default = CollapseInline;
